
import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../../api/ChatbotApi';

function ExternalSources(props) {

    const getText = usePJStore((state) => state.i18n_getText)
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)


    const [loading, setLoading] = useState(false);
    const [externalSources, setExternalSources] = useState([]);
    const [extSource, setExtSource] = useState([]);

    const loadExternalSources = () => {
        setLoading(true);
        PJAxios().post('/chatbot/getExternalSources', { idNode: props.selectedNode != null ? props.selectedNode.idNode : - props.tematica.id_config }).then((res) => {
            setExternalSources(res.data);
        }).finally(() => {
            setLoading(false)
        });
    }

    useEffect(() => {
        if (props.selectedNode != null) {
            loadExternalSources()
        }

    }, [props.selectedNode]);

    const deleteExternalSource = (rowData) => {
        PJAxios().post('/gestioneConfigurazioni/deleteExternalSource', { idNode: rowData.ID_NODE, extSource: rowData.EXT_SOURCE }).then((res) => {
            loadExternalSources()
            flushCache(dbTest);
        });
    }

    const addExternalSource = () => {
        PJAxios().post('/gestioneConfigurazioni/addExternalSource', { idNode: props.selectedNode != null ? props.selectedNode.idNode : - props.tematica.id_config, extSource: extSource }).then((res) => {
            loadExternalSources()
            flushCache(dbTest);
        });
    }


    const actionBodyTemplate = (rowData) => {
        return (
            <Button id={rowData.ext_source} icon="pi pi-trash" className="p-button-primary" label={getText("ELIMINA")} onClick={() => deleteExternalSource(rowData)} ></Button>
        );
    }

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading &&
                <>

                    <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("EXTERNAL_SOURCES")}</b></h6></span>
                    <div className=" formgroup-inline">
                        <div className=" formgroup-inline col-6">
                            <DataTable
                                dataKey="external_source"
                                size="small" stripedRows value={externalSources} responsiveLayout="scroll">
                                <Column className="centeredColumn" field="EXT_SOURCE" header={getText("EXTERNAL_SOURCE")}></Column>
                                <Column body={actionBodyTemplate} header={getText("AZIONI")} exportable={false}></Column>
                            </DataTable>
                        </div>
                        <div className=" formgroup-inline col-6">
                            <div className='col-9'>
                                <InputText value={extSource} placeholder={getText("INSERT_NEW_SOURCE")} style={{ width: "100%" }} onChange={(e) => setExtSource(e.target.value)} />
                            </div>
                            <div className='col-3'>
                                <Button onClick={() => addExternalSource()} label={getText("AGGIUNGI")} />
                            </div>


                        </div>
                    </div>
                </>

            }
        </>
    )
}

export default ExternalSources
